import { Formik } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import {
  isEmpty,
  ContextualHelp,
  Column,
  Form,
  Row,
  Checkbox,
  RadioSelect,
  Container,
  SubmitButton,
  Heading,
  useNotifier,
  useTranslateError,
  useBrowser,
  useBackend,
} from "lcm-iot-commons";

import SignUpBreadcrumb from "./SignUpBreadcrumb";
import { SignUpTileSlider } from "./SignUpTileSlider";

export function SignInTermsConfirmation() {
  const backend = useBackend();
  const browser = useBrowser();
  const intl = useIntl();
  const notifier = useNotifier();
  const translateError = useTranslateError();
  const { mutateAsync: updateUserTerms } =
    backend.patch.useMutation("/users/terms");

  const onSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    try {
      const response = (await updateUserTerms({
        newsletter: values.newsletter,
      })) as { redirect_uri: string };

      browser.redirectToExtern(response.redirect_uri);
    } catch (apiErrors) {
      notifier.showError(translateError(apiErrors));
    }
    actions.setSubmitting(false);
  };

  const validateForm = (values: $TSFixMe) => {
    const errors = {};

    if (!values.terms) {
      (errors as $TSFixMe).terms = intl.formatMessage({
        id: "validation.terms.mandatory",
      });
    }

    if (isEmpty(values.newsletter)) {
      (errors as $TSFixMe).newsletter = intl.formatMessage({
        id: "validation.option.invalid",
      });
    }

    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;

    const newletterHelp = (
      <ContextualHelp
        title={intl.formatMessage({ id: "signup.newsletter.title" })}
      >
        <p>{intl.formatMessage({ id: "signup.newsletter.help_info_1" })}</p>
        <p>{intl.formatMessage({ id: "signup.newsletter.help_info_2" })}</p>
      </ContextualHelp>
    );

    const newsletterOptions = [
      {
        value: "true",
        label: intl.formatMessage({ id: "signup.newsletter.yes" }),
        contextualHelp: newletterHelp,
      },
      {
        value: "false",
        label: intl.formatMessage({ id: "signup.newsletter.no" }),
      },
    ];

    const termsLabel = (
      <span>
        <FormattedMessage id="signup.accept_terms" />
        &nbsp;
        <a href="/legal/terms-of-service" target="_new" id="signin_tos_url">
          <FormattedMessage id="signup.terms" />
        </a>
        &nbsp;
        <FormattedMessage id="signup.and" />
        &nbsp;
        <a href="/legal/privacy-policy" target="_new" id="signin_privacy_url">
          <FormattedMessage id="signup.privacy_policy" />
        </a>
      </span>
    );

    return (
      <Form {...formProps}>
        <RadioSelect
          {...formProps}
          id="newsletter"
          name="newsletter"
          label="Radio Select"
          options={newsletterOptions}
        />
        <br />
        <Checkbox
          {...formProps}
          id="terms"
          name="terms"
          labelNode={termsLabel}
        />
        <SubmitButton
          id="sign-in"
          text={intl.formatMessage({ id: "signin.button.signin" })}
          fetching={isSubmitting}
        />
      </Form>
    );
  };

  return (
    <Container>
      <Row>
        <div className="col-md-12">
          <SignUpBreadcrumb current="confirmation" action="signinterms" />
        </div>
        <Column md="7">
          <Heading
            id="header"
            title={intl.formatMessage(
              { id: "signinterms.header" },
              { username: "" },
            )}
          />
          <p className="space-after">
            {intl.formatMessage({ id: "signinterms.introduction" })}
          </p>
          <br />
          <Formik
            validate={validateForm}
            onSubmit={onSubmit}
            initialValues={{}}
          >
            {renderForm}
          </Formik>
        </Column>
        <Column md="4">
          <div
            id="signin_customer_feedback"
            data-testid="signin_customer_feedback"
            className="sign-up-customer-feedback-block"
          >
            <SignUpTileSlider />
          </div>
        </Column>
      </Row>
    </Container>
  );
}

export default SignInTermsConfirmation;
